import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';

import style from './style.module.css';

export const ProviderStatus = () => {
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.providerStatus} />} labelClassName={style.label}>
      <span className={style.info}>
        <FormattedMessage {...messages.providerStatusPickupUp} />
      </span>
    </LabeledRow>
  );
};
